import type { ZodType } from 'zod/v4'
import type { Json } from '../db/supabase.types.ts'

export function parseJSONData<T>(data: Json, schema?: ZodType<T>) {
  if (!data || typeof data === 'number' || typeof data === 'boolean') {
    return undefined
  }

  let stringData = ''
  let objData: unknown

  if (typeof data === 'string') {
    if (!data || data === '{}') {
      return undefined
    }

    stringData = data
  } else {
    const keys = Object.keys(data)

    objData = keys.length === 1 && keys[0] === 'json' ? (data as { json: unknown }).json : data
  }

  if (stringData) {
    objData = JSON.parse(stringData)
  }

  if (!schema) {
    return objData as T
  }

  try {
    return schema.parse(objData)
  } catch (error) {
    console.log('Error parsing JSON data:', error)
    return undefined
  }
}
